<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="当天日期">
<!--                  <el-input  v-model="queryForm.dayDate"></el-input>-->
                  <el-date-picker
                      style="width: 177px;"
                      size="small"
                      v-model="queryForm.dayDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
<!--              <el-form-item label="执行状态">-->
<!--                  <el-input  v-model="queryForm.exeStatus"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="执行日志">-->
<!--                  <el-input  v-model="queryForm.exeLog"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data1"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data2"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data3"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data4"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data5"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data6"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data7"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data8"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data9"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data10"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data11"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="">-->
<!--                  <el-input  v-model="queryForm.data12"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getReportGlobalvalueDailyStoreList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addReportGlobalvalueDailyStore"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editReportGlobalvalueDailyStore(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteReportGlobalvalueDailyStore(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入"xls"或"xlsx"格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshReportGlobalvalueDailyStoreList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="reportGlobalvalueDailyStoreList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exeStatus"
        label="执行状态"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exeLog"
        label="执行日志"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data1"
        label="总流水金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data2"
        label="总应收金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data3"
        label="总让利金额-100%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data4"
        label="总流水金额(现金)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data5"
        label="总应收金额(现金)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data6"
        label="总让利金额(现金)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data7"
        label="总流水金额(用券)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data8"
        label="总应收金额(用券)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data9"
        label="总让利金额(用券)"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data10"
        label="分享用户-5%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data11"
        label="服务商家-5%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data12"
        label="招商经理-5%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data13"
        label="合伙人-5%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data14"
        label="合伙人平级-5%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data15"
        label="更换门头-2%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data16"
        label="省代-2%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data17"
        label="市代-3%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data18"
        label="区代-5%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data19"
        label="手续费-1%"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkReportGlobalvalueDailyStore(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editReportGlobalvalueDailyStore(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteReportGlobalvalueDailyStore(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="reportGlobalvalueDailyStoreStates[reportGlobalvalueDailyStoreState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="reportGlobalvalueDailyStore"
          ref="reportGlobalvalueDailyStoreForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="reportGlobalvalueDailyStore.dayDate"-->
<!--              :disabled="reportGlobalvalueDailyStoreState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style="width: 177px;"
                  size="small"
                  v-model="reportGlobalvalueDailyStore.dayDate"
                  :disabled="reportGlobalvalueDailyStoreState == 'check'"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="执行状态"-->
<!--            prop="exeStatus"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="reportGlobalvalueDailyStore.exeStatus"-->
<!--              :disabled="reportGlobalvalueDailyStoreState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="执行日志"-->
<!--            prop="exeLog"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="reportGlobalvalueDailyStore.exeLog"-->
<!--              :disabled="reportGlobalvalueDailyStoreState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="总流水金额"
            prop="data1"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data1"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总应收金额"
            prop="data2"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data2"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总让利金额-100%"
            prop="data3"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data3"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总流水金额(现金)"
            prop="data4"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data4"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总应收金额(现金)"
            prop="data5"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data5"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总让利金额(现金)"
            prop="data6"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data6"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总流水金额(用券)"
            prop="data7"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data7"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总应收金额(用券)"
            prop="data8"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data8"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总让利金额(用券)"
            prop="data9"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data9"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分享用户-5%"
            prop="data10"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data10"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="服务商家-5%"
            prop="data11"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data11"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="招商经理-5%"
            prop="data12"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data12"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="合伙人-5%"
            prop="data13"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data13"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="合伙人平级-5%"
            prop="data14"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data14"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="更换门头-2%"
            prop="data15"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data15"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="省代-2%"
            prop="data16"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data16"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="市代-3%"
            prop="data17"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data17"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="区代-5%"
            prop="data18"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data18"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="手续费-1%"
            prop="data19"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="reportGlobalvalueDailyStore.data19"
              :disabled="reportGlobalvalueDailyStoreState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="reportGlobalvalueDailyStoreState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetReportGlobalvalueDailyStoreList();
                    this.getReportGlobalvalueDailyStoreList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetReportGlobalvalueDailyStoreList();
                    this.getReportGlobalvalueDailyStoreList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     dayDate: '', //
                     exeStatus: '', //执行状态
                     exeLog: '', //执行日志
                     data1: '', //
                     data2: '', //
                     data3: '', //
                     data4: '', //
                     data5: '', //
                     data6: '', //
                     data7: '', //
                     data8: '', //
                     data9: '', //
                     data10: '', //
                     data11: '', //
                     data12: '', //
                     data13: '', //
                     data14: '', //
                     data15: '', //
                     data16: '', //
                     data17: '', //
                     data18: '', //
                     data19: '', //
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                reportGlobalvalueDailyStoreState: 'add',
                reportGlobalvalueDailyStoreStates: {
                    add: '新建门店每日数据',
                    check: '查看门店每日数据',
                    edit: '修改门店每日数据'
                },

                multipleSelection: [],
                reportGlobalvalueDailyStoreList: [],
                reportGlobalvalueDailyStore: {
                    id: '', //
                    dayDate: '', //
                    exeStatus: '', //执行状态
                    exeLog: '', //执行日志
                    data1: '', //
                    data2: '', //
                    data3: '', //
                    data4: '', //
                    data5: '', //
                    data6: '', //
                    data7: '', //
                    data8: '', //
                    data9: '', //
                    data10: '', //
                    data11: '', //
                    data12: '', //
                    data13: '', //
                    data14: '', //
                    data15: '', //
                    data16: '', //
                    data17: '', //
                    data18: '', //
                    data19: '', //
                },
                btnLoading: false,

                rules: {
                    dayDate: [{ required: true, message: '当前日期不能为空', trigger: 'blur' }],
                    exeStatus: [{ required: true, message: '执行状态不能为空', trigger: 'blur' }],
                    exeLog: [{ required: true, message: '执行日志不能为空', trigger: 'blur' }],
                    data1: [{ required: true, message: '总流水金额不能为空', trigger: 'blur' }],
                    data2: [{ required: true, message: '总应收金额不能为空', trigger: 'blur' }],
                    data3: [{ required: true, message: '总让利金额-100%不能为空', trigger: 'blur' }],
                    data4: [{ required: true, message: '总流水金额(现金)不能为空', trigger: 'blur' }],
                    data5: [{ required: true, message: '总应收金额(现金)不能为空', trigger: 'blur' }],
                    data6: [{ required: true, message: '总让利金额(现金)不能为空', trigger: 'blur' }],
                    data7: [{ required: true, message: '总流水金额(用券)不能为空', trigger: 'blur' }],
                    data8: [{ required: true, message: '总应收金额(用券)不能为空', trigger: 'blur' }],
                    data9: [{ required: true, message: '总让利金额(用券)不能为空', trigger: 'blur' }],
                    data10: [{ required: true, message: '分享用户-5%不能为空', trigger: 'blur' }],
                    data11: [{ required: true, message: '服务商家-5%不能为空', trigger: 'blur' }],
                    data12: [{ required: true, message: '招商经理-5%不能为空', trigger: 'blur' }],
                    data13: [{ required: true, message: '合伙人-5%不能为空', trigger: 'blur' }],
                    data14: [{ required: true, message: '合伙人平级-5%不能为空', trigger: 'blur' }],
                    data15: [{ required: true, message: '更换门头-2%不能为空', trigger: 'blur' }],
                    data16: [{ required: true, message: '省代-2%不能为空', trigger: 'blur' }],
                    data17: [{ required: true, message: '市代-3%不能为空', trigger: 'blur' }],
                    data18: [{ required: true, message: '区代-5%不能为空', trigger: 'blur' }],
                    data19: [{ required: true, message: '手续费-1%不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getReportGlobalvalueDailyStoreList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(){
                this.resetReportGlobalvalueDailyStoreList();
                this.getReportGlobalvalueDailyStoreList();
            },
            resetReportGlobalvalueDailyStoreList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.reportGlobalvalueDailyStoreList = [];
            },
            resetDialog() {
                this.reportGlobalvalueDailyStoreState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      dayDate: '', //
                      exeStatus: '', //执行状态
                      exeLog: '', //执行日志
                      data1: '', //
                      data2: '', //
                      data3: '', //
                      data4: '', //
                      data5: '', //
                      data6: '', //
                      data7: '', //
                      data8: '', //
                      data9: '', //
                      data10: '', //
                      data11: '', //
                      data12: '', //
                      data13: '', //
                      data14: '', //
                      data15: '', //
                      data16: '', //
                      data17: '', //
                      data18: '', //
                      data19: '', //
                };
                this.getReportGlobalvalueDailyStoreList();
            },
            closeDialog() {
                this.showDialog = false
                this.reportGlobalvalueDailyStore = {
                      id: '', //
                      dayDate: '', //
                      exeStatus: '', //执行状态
                      exeLog: '', //执行日志
                      data1: '', //
                      data2: '', //
                      data3: '', //
                      data4: '', //
                      data5: '', //
                      data6: '', //
                      data7: '', //
                      data8: '', //
                      data9: '', //
                      data10: '', //
                      data11: '', //
                      data12: '', //
                      data13: '', //
                      data14: '', //
                      data15: '', //
                      data16: '', //
                      data17: '', //
                      data18: '', //
                      data19: '', //
                };
            },
            submitForm() {
                if (this.reportGlobalvalueDailyStoreState == 'add') {
                    this.$refs.reportGlobalvalueDailyStoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/globalvaluedailystore/add`,{ ...this.reportGlobalvalueDailyStore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetReportGlobalvalueDailyStoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.reportGlobalvalueDailyStoreState == 'edit') {
                    this.$refs.reportGlobalvalueDailyStoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/globalvaluedailystore/edit`,{ ...this.reportGlobalvalueDailyStore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetReportGlobalvalueDailyStoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addReportGlobalvalueDailyStore() {
                this.showDialog = true;
                this.reportGlobalvalueDailyStoreState = 'add';
            },
            checkReportGlobalvalueDailyStore(reportGlobalvalueDailyStoreId) {
                console.log(reportGlobalvalueDailyStoreId);
                this.currentReportGlobalvalueDailyStoreId = reportGlobalvalueDailyStoreId;

                this.getReportGlobalvalueDailyStoreById();
                this.showDialog = true;
                this.reportGlobalvalueDailyStoreState = 'check';
            },
            editReportGlobalvalueDailyStore(reportGlobalvalueDailyStoreId) {
                console.log('reportGlobalvalueDailyStore', reportGlobalvalueDailyStoreId);
                if (reportGlobalvalueDailyStoreId) {
                    this.currentReportGlobalvalueDailyStoreId = reportGlobalvalueDailyStoreId;
                    this.getReportGlobalvalueDailyStoreById();
                } else {
                    this.reportGlobalvalueDailyStore = { ...this.reportGlobalvalueDailyStore, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.reportGlobalvalueDailyStoreState = 'edit';
            },
            deleteReportGlobalvalueDailyStore(reportGlobalvalueDailyStoreId) {
                let ids = '';
                if (reportGlobalvalueDailyStoreId) {
                    ids = reportGlobalvalueDailyStoreId;
                } else {
                    ids = this.multipleSelection.map((reportGlobalvalueDailyStore) => reportGlobalvalueDailyStore.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/report/globalvaluedailystore/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetReportGlobalvalueDailyStoreList();
                                this.getReportGlobalvalueDailyStoreList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshReportGlobalvalueDailyStoreList() {
                this.resetReportGlobalvalueDailyStoreList();
                this.getReportGlobalvalueDailyStoreList();
            },
            getReportGlobalvalueDailyStoreList(query = {}) {
                this.loading = true;
                get(`/report/globalvaluedailystore/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.reportGlobalvalueDailyStoreList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getReportGlobalvalueDailyStoreById() {
                get(`/report/globalvaluedailystore/get`,{ id: this.currentReportGlobalvalueDailyStoreId }).then((res) =>{
                    if(res.success){
                      this.reportGlobalvalueDailyStore = { ...this.reportGlobalvalueDailyStore, ...res.reportGlobalvalueDailyStore };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportReportGlobalvalueDailyStoreList() {
                //this.btnLoading = true;
                exprotExcel(`/report/globalvaluedailystore/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/report/globalvaluedailystore/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/report/globalvaluedailystore/importData`,formData);
              this.refreshReportGlobalvalueDailyStoreList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getReportGlobalvalueDailyStoreList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getReportGlobalvalueDailyStoreList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>